import React from 'react';
import { Layout, RoutesMenu, GetInfo } from '../../components';
import '../../assets/styles/containers/Routes.sass';

const Prologo = () => {
  return (
    <div className="Prologo">
      <Layout bannerId={71}>
        <RoutesMenu/>
        <div className="container">
          <GetInfo id={138}/>
        </div>
      </Layout>
    </div>
  );
};

export default Prologo;
